import { CommonTabbarContext } from "@/App";
import { getServerDetail } from "@/api/device/server";
import { DEVICE_TYPE } from "@/enums/device-type";
import { TAB_TYPE } from "@/enums/tab-type";
import { CommonTabbarState, TabRoute } from "@/global/components/common-tabbar";
import { Server } from "@/global/interface/device/server";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export default function ServerPanel(second) {

    const commonTabbarContext = useContext<CommonTabbarState>(CommonTabbarContext);

    const { deviceId } = useParams()

    const [data, setData] = useState<Server>(null)
    // 初始化
    useEffect(() => {
        if (!deviceId) return;
        getServerDetail(Number(deviceId)).then(res => {
            let resServer: Server = res.data
            setData(resServer)

            let addTab: TabRoute = {
                title: resServer?.name || '',
                url: `${TAB_TYPE.DEVICE}/${deviceId}/${DEVICE_TYPE.SERVER}`,
                closable: true
            }
            commonTabbarContext.pushRoute(addTab)
        })

    }, [])

    return (
        <>
            我是服务器详情
        </>
    )
}